import * as angular from 'angular';
import { StateService } from '@uirouter/angularjs';

import { stateChangeSuccess } from '../../../common/events';
import { ComponentDefinition } from '../../../models';

class ApplicationUsersController implements angular.IComponentController {
    currentState: string;
    isLoading: boolean;
    loadingMessage: string;

    static $inject = [
        '$scope',
        '$state'
    ];
    constructor(
        private _$scope: angular.IScope,
        private _$state: StateService
    ) {
    }

    $onInit() {
        this.currentState = this._$state.current.name;
        this._$scope.$on(stateChangeSuccess, (event, toState) => {
            this.currentState = toState.name;
        });
    }
}

export const wtApplicationUsers: ComponentDefinition = {
    componentId: 'wtApplicationUsers',
    controller: ApplicationUsersController,
    template: require('./applicationUsers.component.html'),
    controllerAs: 'vm',
    bindings: {}
};
